// import $ from 'jquery';
import { debounce as _debounce } from 'underscore';
import { gsap } from 'gsap';
//import { DrawSVGPlugin	 } from 'gsap/DrawSVGPlugin';
//gsap.registerPlugin(DrawSVGPlugin);

import inView from 'in-view';

// MOVED TO LIBS-HEAD.js
// import './../../libs/custom/slick';
// import 'slick-carousel';

export default class {

    constructor(options) {

        // OPTIONS
        this.defaults = {

            $el: undefined,

            arrows: false,
            autoplay: false,
            dots: true,
            autosize: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            cssEase: 'ease',
            pauseOnHover: false,
            autoplaySpeed: 3000,
            speed: 800,
            defaultResponsive : true,
            customArgs: false,
            responsive: true,
            delayAutoplay: false,
            unslickMobile: false,
            adaptiveHeight: false,

            infinite: true,
            asNavFor: false,
            centerMode: false,

            initialSlide: 0,

            // this are set as default in slick.
            /*
			if you want to crossfade (slide of different sizes) specify
			crossFade = true
            */
            crossFade:  false,
            gsap:       true,
            gsap_ease:  'circ.out',
            setSameSlideHeight: false
        }

		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace  = 'slideshow_ctrl';

		// DOM ELEMENT !!!!!!!!!!
		this.$el = this.options.$el;

		// init!!!!
		if ( this.$el.length > 0 ){
			this.init();
		}

    }

	init(){
		// vars
		this.$win = $(window);
		this.$doc = $(document);
		this.$html = $('html');
		this.$body = $( 'body' );
		this.touch = !$('html').hasClass('no-touch');
		this.slides = [];

		this.$slick = this.$el.find( '> .slick-slider' );

		if ( this.$el.hasClass( 'autosize-available-viewport' ) ){
			this.onResize();
		}

		this.initSlider( true );
		//this.addEvents( true );

		this.onResize();
	}

	initSlider( b ){
		let $s = this.$slick;

		if ( !$s ){
			return;
		}

		if ( b ){

			if ( ! $s.hasClass( 'slick-initialized' ) ){

				if ( this.options.autosize ){
					this.sizeImages();
				}

				$s.on( 'init', () => {
					if ( this.$el.find( '.arrow' ).length > 0 ){
						this.$el.find( '.arrow' ).css({
							'visibility': 'visible'
						})
					}
					this.$el.addClass( 'slideshow-ctrl-init' );
					if ( this.$el.hasClass( 'force-load' ) ){
						this.FORCE_IMAGE_LOAD()
					}
				});

				$s.on( 'swipe', () => {
					if ( $s.hasClass( 'drag' ) ){
						$s.removeClass( 'drag' ).removeClass( 'cursor' );
					}
					else{
						$s.addClass( 'drag' ).addClass( 'cursor' );
					}
				});

				$s.on( 'mouseleave, mouseup', () => {
					$s.removeClass( 'drag' ).removeClass( 'cursor' );
				});

				// defaults to fade
				let args = this.options;

				if ( this.options.arrows ){
					args.prevArrow = this.$el.find(  '.arrow-left' );
					args.nextArrow = this.$el.find(  '.arrow-right' );
				}

				// if ( this.options.responsive ){
				// 	args.responsive = [{
				// 		breakpoint: 767,
				// 		settings: {
				// 			fade: false,
				// 			speed: (this.options.speed / 3)
				// 		}
				// 	}]
				// }

				if ( this.options.unslickMobile ){
					args.responsive = [{
						breakpoint: 767,
						settings: "unslick"
					}]
				}


				if ( this.options.customArgs && this.options.args ){
					args = this.options.args
					this.options = args;
				}

				this.initSLIDES(b);

				//console.log(args, 'slideshowCtl args');

				$s.slick( args );

				if ( this.options.delayAutoplay && this.options.autoplay ){
					$s.slick( 'slickPause' );
					setTimeout( () => {
						$s.slick( 'slickPlay' );
					}, this.options.delayAutoplay );
				}

			}

		}
		else{

			if ( $s.hasClass( 'slick-initialized' ) ){
				$s.removeClass( 'slick-initialized' );
				$s.slick('unslick');
			}

		}

		//console.log( 'initSlider, b = ' + b );

		//if ( ! $s.hasClass( 'slick-initialized' ) ){
			this.addEvents( b );
			this.attachEventsSlick( b );
			this.addFadeCaptions( b );
		//}

	}

	forceReInit(){
		gsap.set( this.$el, {opacity:0} );
		this.initSlider( false );
		if ( this.reInit ){
			clearTimeout( this.reInit );
		}
		this.reInit = setTimeout( ()=>{
			this.initSlider( true );
			gsap.fromTo( this.$el, {opacity:0}, {opacity:1, duration: 0.5} );
		}, 300 )
	}

    addEvents( b ){
		if ( b ){
		
			if ( this.$slick.hasClass( 'click-to-advance' ) ){

				this.$el.find( 'img' ).on( 'click', (e) => {
					this.nextSlide( e.offsetX > $(e.currentTarget).width()/2 );
				});

			}

		}
		else{

			if ( this.$slick.hasClass( 'click-to-advance' ) ){
				this.$el.find( 'img' ).off( 'click' );
			}
		}
		this.debounceResize(b);
    }

    FORCE_IMAGE_LOAD(){
        this.$el.find( 'img' ).addClass( 'lazypreload' );
    }

    debounceResize(b){
		if ( b ){
			// debounce resize
			this._debResize = _debounce( () => {
				this.onResize();
			}, 117 );
			this.$win.on( 'resize', this._debResize );
		}
		else{
			if ( this._debResize ){
				this._debResize.cancel();
				this.$win.off( 'resize', this._debResize );
			}        
		}
    }

    onResize(){
		let w = this.$win.width(), h = this.$win.height(), availableHeight, p, $s = this.getSlider(), max, ww;

		// resize goes here
		if ( this.$el.hasClass( 'autosize-available-viewport' ) ){

			// if there is a max width
			if ( !this.$el.data('max-width') ){
				max = parseInt( this.$el.css( 'max-width' ) );
				if ( max ){
					this.$el.data('max-width', max  )
				}
			}

			availableHeight = h - this.$el.offset().top - 120; //h - $( 'main header' ).outerHeight( true ) - 120;

			p = 1/this.getImagesProportion();

			if ( p ){

				// max (check if there is a max-width)
				ww = Math.floor( availableHeight*p );

				if ( this.$el.data('max-width') ){
					ww = Math.min( ww, this.$el.data('max-width') );
				}

				// min (don't go below too much ... )
				if ( w >=768 ){
					ww = Math.max( ww, 680 );
				}

				this.$el.css({
					'max-width': ww
				});

				// force refresh, but slick give errors!!!!
				if ( $s.hasClass( 'slick-initialized' ) ){
					//console.log( $s.slick );
					//$s.slick( 'resize' )
				}
			}
		}

		//console.log( this.options )

		if ( this.options.setSameSlideHeight  ){
			this.$el.find( '.slide-wrap' ).css(  {'height' : 'auto'} );
			h = this.$el.find( '.slick-track' ).height();
			this.$el.find( '.slide-wrap' ).height( h );
		}
    }

    nextSlide( b ){
      	if ( b ){
        	this.$slick.slick( 'slickNext' );
      	}
      	else{
        	this.$slick.slick( 'slickPrev' );
      	}
    }

    attachEventsSlick( b ){
      	let $slick = this.$slick;

		this.attachEventsKeyBoard(b);

		if ( b ){

			$slick.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
		  		this.onSlideBeforeChange( currentSlide, nextSlide );
			});

			$slick.on('afterChange', (event, slick, currentSlide) => {
			 	this.onSlideAfterChange( currentSlide );
			});

		}
		else{

			$slick.off('beforeChange');
			$slick.off('afterChange');
		
		}
    }

    attachEventsKeyBoard( b ){

    	//console.log( 'attachEventsKeyBoard,  b = ' + b );

		if ( b ){
			if  ( ! this.events_keyboard_attach ){

				this.events_keyboard_attach =   true;      
				this.$doc.on( 'keydown' , (e) => {

					if ( !inView.is( this.$el[0] ) ){
						return;
					}

					//console.log( e )

					if( e.which === 39 || e.which === 40 ){
						// right arrow or dn
						this.$slick.slick( 'slickNext' );
					}
					else if ( e.which === 37 || e.which === 38 ){
						// left arrow or up
						this.$slick.slick( 'slickPrev' );
					}
				});

			}
		}
		else{
			this.$doc.off( 'keydown' );
			this.events_keyboard_attach =   false;
		}
    }

    getImagesProportion(){
		let $slide = this.$el.find( '.slick-slide:eq(0)' ), $wrapper, p;
		$wrapper = $slide.find( '.img-wrapper' );
		if ( $wrapper.length > 0 ){
			p = parseInt( $wrapper.attr('data-height') )/parseInt( $wrapper.attr('data-width') )
			return p;
		}
		return false;
    }

    sizeImages(){
		let p = this.getImagesProportion(), $r;
		if ( p ){
			$r = this.$el.find('.img-wrapper');
			if ( $r.length > 0 ){
				$r.css({
					'padding-bottom' : (p*100) + '%'
				})
			}
		}
    }

    initSLIDES(b){
		let $m, $v, mode, i, s;

		if ( b ){
			this.$el.find( '.slide' ).each( (i, el) => {
				$m = $(el);
				mode = 'image';

				$v = $m.find( '.video-ctrl' );
				if (  $v.length > 0 ){
					mode = 'video';
					$v.video_ctrl({ 
		  				autoplay: $v.hasClass('autoplay-off') ? false : true
					});
				}

				if ( $m.find( '.video-vimeo' ).length > 0  ){
					$v   = $m.find( '.video-vimeo' );
					mode = 'video-vimeo';
				}

				this.slides[i] = {
					$el : $m,
					mode : mode,
					$v : $v
				}
			});
		}
		else{
			i = this.slides.length;
			while( i-- ){
				s = this.slides[i];
				if ( s.mode === 'video' ){
					$v = s.$v;
					$v.video_ctrl( 'destroy' );
				}
			}
		}
    }

    refreshSizes(){
		let i = this.slides.length, s, $v, widget;
		while( i-- ){
			s = this.slides[i];
			if ( s.mode === 'video-vimeo' ){
				$v = s.$v;
				widget = $v.data( 'widget' );
				if ( widget ){
					widget.onResize()
				}
			}
		}
    }

    onSlideBeforeChange( current, next ){
        let c = this.slides[ current ], n = this.slides[ next ], $v;

        //console.log( 'onSlideBeforeChange, current = ' + current + ', next = ' + next );

        // pause current video
        if ( c && c.mode === 'video' ){
          	$v = c.$v;
          	$v.video_ctrl( 'play', false );
        }

        // pause current vimeo video
        if ( c && c.mode === 'video-vimeo' ){
          	$v = c.$v.data( 'widget' );
          	if ( $v ){
          		setTimeout( () => $v.play( false ), this.options.speed );
          	}
        }
        
        // activate next vimeo
        if ( n && n.mode === 'video-vimeo' ){
          	$v = n.$v.data( 'widget' );
          	if ( $v ){
          		$v.play( true );
          	}
        }

        /*
        this.clearBulletIndicator( current )
        let t = this.options.autoplaySpeed + this.options.speed;
        this.setLoadingBulletIndicator( next, t )
		*/


        //------------------- CORRECT SLICK DOTS WHEN OVER BLACK SLIDE -------------------------//
        // this._correctSlickDotsOpacity( next );        
    }

    /*
    setLoadingBulletIndicator( i, t ) {
        let $arc = $('.arc');

        gsap.set( $arc, {
            drawSVG: "0%"
        });

        gsap.to($arc, {
        	duration: t,
            drawSVG: '100%',
            ease: 'linear.easeNone'
        })
    }
    clearBulletIndicator( i ) {
        let $arc = $('.arc');

        gsap.killTweensOf( $arc);

        gsap.set( $arc, {
            clearProps: "stroke-dasharray, stroke-dashoffset"
        })
    }
	*/

    onSlideAfterChange( current ){
        var s = this.slides[ current ], $v, $aleft = this.$el.find( '.arrow-left' );
        // play current video
        if ( s && s.mode === 'video' ){
          	$v = s.$v;
          	$v.video_ctrl( 'play', true );
        }

        if ( $aleft.length > 0 ){
          	$aleft.addClass( 'reveal' );
        }
    }

    // _correctSlickDotsOpacity: function( next ){
    //     var $s = this.slides[ next ].$el, $d;
    //     if ( $s.find( '.frame' ).length > 0 ){
    //         $d = this.$el.find( '.slick-dots' );
    //         if ( $d.length > 0 ){
    //             TweenMax.to( $d, 0.3, { opacity: $s.find( '.bg-black' ).length > 0 ? 0.5 : 1 } );
    //         }
    //     }
    // },

    addFadeCaptions(b){

		if ( !this.$el.hasClass( 'fade-captions' ) ){
			return;
		}

		let $li, $slick = this.$slick;
		this.$captions = this.$el.find( 'ul.captions' );
		if ( this.$captions.length > 0 ){
			if (b){

				// set first default --------------------//
				this.$captions.find('li:first-child').addClass( 'current' );

				$slick.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
					this.$captions.find( 'li' ).removeClass( 'current' );
					$li = this.$captions.find('li:eq(' + nextSlide + ')');
					if ( $li.length > 0 ){
				  		$li.addClass( 'current' );
				  		gsap.fromTo( $li, 0.8, {opacity:0},{opacity:1,ease:'Sine.easeOut'} );
					}               
				});
			}
			else{
				$slick.on('beforeChange');
			}
		}
    }

    destroy(){
		this.initSLIDES( false );
		this.initSlider( false );
		this.addEvents( false );
		this.$el.removeData();
		this.$el.removeClass( 'slideshow-ctrl-init' );
    }

    play(b){
		if ( b ){
			//this.$slick.slick( 'slickNext' );
			this.$slick.slick( 'slickSetOption', 'autoplay', true );
			this.$slick.slick( 'slickSetOption', 'pauseOnHover', false );
			this.$slick.slick( 'slickPlay' );
		}
		else{
			this.$slick.slick( 'slickPause' ); 
		}
    }

    setAutoplay( s ){
      	this.$slick.slick( 'slickSetOption', 'autoplaySpeed', s );
      	this.play(true);
    }

    getSlider(){
      	return this.$slick;
    }

}

